import { useNavigate } from "react-router";
import { useDrops } from "../../store/useDrops";
import dayjs from "dayjs";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";

export const DropsTable = () => {
  /** Hooks */
  const { drops, deleteDrop } = useDrops();
  const navigate = useNavigate();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Drop
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Location
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Amount
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Price
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Feedbacks
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Status
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Date
            </th>
            <th
              scope="col"
              className="hidden min-w-[200px] sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Joined Lotteries
            </th>
            <th
              scope="col"
              className="hidden min-w-[200px] sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Rejected Lotteries
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {drops?.map((drop) => {
            // const openDropDetails = () => navigate("/drop-details/292010");
            const isApproved = drop?.status === "approved";
            const isDeclined = drop?.status === "declined";
            const isPending = drop?.status === "pending";

            return (
              <tr
                key={drop?._id}
                className="bg-white border-b cursor-pointer hover:bg-gray-50"
                // onClick={openDropDetails}
              >
                <th
                  onClick={() => navigate(`/edit-drop/${drop?._id}`)}
                  scope="row"
                  className="px-2 sm:px-6 py-1 sm:py-4 text-xs sm:text-base font-bold text-primary-base whitespace-nowrap"
                >
                  #{drop?._id}
                </th>
                <td
                  onClick={() => navigate(`/edit-drop/${drop?._id}`)}
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {/* @ts-ignore */}
                  {drop?.location?.[0]?.cost_place}
                </td>
                <td
                  onClick={() => navigate(`/edit-drop/${drop?._id}`)}
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {Number(drop?.totalWeight).toFixed(2)}
                  {" kg"}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  {Number(
                    (drop?.totalPrice ? drop?.totalPrice / 100 : 0)?.toFixed(2)
                  )}{" "}
                  €
                </td>
                <td
                  onClick={() => navigate(`/edit-drop/${drop?._id}`)}
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {drop?.dropFeedback?.length ?? 0}
                </td>
                <td
                  onClick={() => navigate(`/edit-drop/${drop?._id}`)}
                  className={`hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4 ${
                    isApproved ? "text-green-500" : ""
                  } ${isPending ? "text-orange-500" : ""} ${
                    isDeclined ? "text-red-500" : ""
                  }`}
                >
                  {drop?.status?.toUpperCase()}
                </td>
                <td
                  onClick={() => navigate(`/edit-drop/${drop?._id}`)}
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {dayjs(drop?.createdAt).format("DD/MM/YY HH:mm")}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4 w-64">
                  {(() => {
                    // Yalnız isFirstTicketDrop: true olan lottery-ləri göstər
                    const firstTicketLotteries =
                      drop?.joinedLottery?.filter(
                        (lottery) => lottery?.isFirstTicketDrop
                      ) || [];

                    return firstTicketLotteries.length > 0 ? (
                      <div className="space-y-1.5">
                        {firstTicketLotteries.map((lottery, index) => (
                          <span
                            key={index}
                            title={lottery?.en_title || "Lottery"}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/edit-lottery/${lottery?._id}`);
                            }}
                            className="block px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800 truncate cursor-pointer max-w-max hover:bg-green-200 transition-colors"
                          >
                            {lottery?.en_title || "Lottery"}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="text-xs text-gray-500">None</span>
                    );
                  })()}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4 w-64">
                  {drop?.rejectedLottery &&
                  drop?.rejectedLottery?.length > 0 ? (
                    <div className="space-y-1.5">
                      {drop?.rejectedLottery?.map((lottery, index) => (
                        <span
                          key={index}
                          title={lottery?.en_title || "Lottery"}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/edit-lottery/${lottery?._id}`);
                          }}
                          className="block px-2 py-1 rounded text-xs font-medium bg-red-100 text-red-800 max-w-max truncate cursor-pointer hover:bg-red-200 transition-colors"
                        >
                          {lottery?.en_title || "Lottery"}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span className="text-xs text-gray-500">None</span>
                  )}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-3 flex items-center justify-end cursor-pointer">
                  <EditIcon
                    title="Edit"
                    onClick={() => navigate(`/edit-drop/${drop?._id}`)}
                    className="mr-3 sm:mr-7"
                  />
                  <TrashIcon
                    title="Delete"
                    onClick={() => {
                      const confirmDelete = window.confirm(
                        "Are you sure you want to delete this drop?"
                      );
                      if (confirmDelete) {
                        deleteDrop(drop._id as string);
                      }
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
